import { useState, type FormEvent } from 'react'
import { ThemeToggle } from '../components/ThemeToggle'
import { api, ApiError, type Principal } from '../lib/api'

/** Only dispatchers sign in. Members never do -- they use the radio card and a
 *  separate app -- so there is no account creation and no password reset flow
 *  aimed at the public. Accounts are made by an org admin. */
export function SignIn({ onSignedIn }: { onSignedIn: (p: Principal) => void }) {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      onSignedIn(await api.signIn(login, password))
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Sign-in failed.')
      setBusy(false)
    }
  }

  return (
    <div className="signin-wrap">
      {/* The switch belongs HERE too, not only in the chrome after signing in.
          This is the first screen anybody sees, and a dispatcher who finds the
          dark theme hard to read should not have to get through a login to say
          so. It is also where somebody testing the product starts. */}
      <div className="signin-theme">
        <ThemeToggle />
      </div>
      <form className="signin" onSubmit={submit}>
        <h1>ADV&#8209;CRM</h1>
        <div className="org">Dispatch console</div>

        {error && <div className="notice">{error}</div>}

        <div className="field">
          <label htmlFor="login">Login</label>
          <input
            id="login"
            value={login}
            autoComplete="username"
            autoFocus
            onChange={(e) => setLogin(e.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button className="primary" type="submit" disabled={busy || !login || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
